// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2nsjx","content":"RecentSearches_content__3Fu3L"};